import { render, staticRenderFns } from "./submit-review.vue?vue&type=template&id=4857d23f&scoped=true&"
import script from "./submit-review.vue?vue&type=script&lang=js&"
export * from "./submit-review.vue?vue&type=script&lang=js&"
import style0 from "./submit-review.vue?vue&type=style&index=0&id=4857d23f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857d23f",
  null
  
)

export default component.exports